<template>
  <div>
    <v-navigation-drawer
      v-if="horizontal"
      app
      fixed
      v-model="drawer"
      :width="250"
      class="vuely-sidebar"
    >
      <!-- App Sidebar -->
      <ServiceSidebar v-if="isServiceSidebar" />
      <app-sidebar v-else />
    </v-navigation-drawer>
  </div>
</template>

<script>
import Sidebar from '../Sidebar/Sidebar.vue'
import ServiceSidebar from '../Sidebar/ServiceSidebar.vue'

import { mapGetters, mapMutations } from 'vuex'
import { isKvmServerPath } from '@/helpers/serverPaths'

export default {
  data: () => ({
    collapsed: false, // collapse sidebar
    chatSidebar: false, // chat component right sidebar
    sidebarImages: '', // sidebar background images
    enableDefaultSidebar: false,
  }),
  props: {
    horizontal: {
      default: true,
      type: Boolean
    }
  },
  components: {
    appSidebar: Sidebar,
    ServiceSidebar,
  },
  computed: {
    ...mapGetters(['brand', 'theme', 'navDrawer']),
    headerColor () {
      return this.$vuetify.theme.dark ? this.theme.dark.header : this.theme.light.header
    },
    drawer: {
      get () {
        return this.navDrawer
      },
      set (val) {
        this.SET_NAV_DRAWER(val)
      }
    },
    isServiceSidebar () {
      return this.$route.path.substring(0, 15) === '/hosting/shared' ||
        this.$route.path.substring(0, 17) === '/hosting/reseller' ||
        isKvmServerPath(this.$route.path)
    }
  },
  methods: mapMutations(['SET_NAV_DRAWER']),
}
</script>
